// extracted by mini-css-extract-plugin
export default {"ul":"TradePlanDisplay_ul__aojYu"};